/* eslint-disable react/style-prop-object */
import React, { ReactElement } from "react";
import { FormattedMessage, FormattedNumber } from "react-intl";
import { formatOvhCity, formatOvhFlag, formatOvhPrice } from "helpers/server";

import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { IOvhCatalogAPI, IOvhPriceRange } from "types/api/ovhApiInterface";

const OvhRecapBox = ({
 ovhCatalog,
 serverCode,
 osOvh,
 locationOvh,
 enableContinuity,
 ovhPrices
}: {
 ovhCatalog: Array<IOvhCatalogAPI>;
 serverCode: string;
 osOvh: string;
 locationOvh: string;
 enableContinuity: boolean;
 ovhPrices: Array<IOvhPriceRange>;
}): ReactElement => {
 return (
  <>
   <Divider sx={{ my: 1 }} />
   <Stack textAlign="left" mb={1}>
    <Typography variant="unboundedTitle" fontSize={14}>
     <FormattedMessage id="server.add.serverSpecs" />
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={150} textAlign="start" fontWeight="bold">
     <FormattedMessage id="server.os" />:
    </Typography>
    <Typography variant="subtitle2" noWrap>
     {osOvh}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={150} textAlign="start" fontWeight="bold">
     <FormattedMessage id="server.type" />:
    </Typography>
    <Typography variant="subtitle2">
     {ovhCatalog.find((element) => element.planCode === serverCode)?.name || ""}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2} alignItems="center">
    <Typography variant="subtitle2" minWidth={150} textAlign="start" fontWeight="bold">
     <FormattedMessage id="server.location" />:
    </Typography>
    <Typography noWrap variant="subtitle2">
     {formatOvhCity(locationOvh)}
    </Typography>
    <Stack component="span" className={`fi fi-${formatOvhFlag(locationOvh)}`} />
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={150} textAlign="start" fontWeight="bold">
     <FormattedMessage id="server.cores" />:
    </Typography>
    <Typography variant="subtitle2">
     {ovhCatalog.find((element) => element.planCode === serverCode)?.cpu || ""}
    </Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={150} textAlign="start" fontWeight="bold">
     <FormattedMessage id="server.add.ram" />:
    </Typography>
    <Typography variant="subtitle2">{`${
     ovhCatalog.find((element) => element.planCode === serverCode)?.memory || "0"
    } GB`}</Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={150} textAlign="start" fontWeight="bold">
     <FormattedMessage id="server.add.disk" />:
    </Typography>
    <Typography variant="subtitle2">{`${
     ovhCatalog.find((element) => element.planCode === serverCode)?.disk[0].capacity || "0"
    } GB`}</Typography>
   </Stack>
   <Stack direction="row" spacing={2}>
    <Typography variant="subtitle2" minWidth={150} textAlign="start" fontWeight="bold">
     BCP:
    </Typography>
    <Typography variant="subtitle2">{enableContinuity ? "Attivo" : "Disattivo"}</Typography>
   </Stack>
   <Divider sx={{ my: 1 }} />
   <Stack>
    <Stack direction="row" spacing={2} alignItems="center">
     <Typography variant="subtitle2" minWidth={150} textAlign="start" fontWeight="bold">
      <FormattedMessage id="server.add.totalPrice" />
     </Typography>
     <Typography variant="subtitle2">
      <FormattedNumber
       value={
        formatOvhPrice(
         ovhPrices,
         ovhCatalog.find((element) => element.planCode === serverCode)?.price || 0
        ) + (enableContinuity ? 5 : 0)
       }
       style={"currency"}
       currency="EUR"
      />
     </Typography>
    </Stack>
   </Stack>
  </>
 );
};

export default OvhRecapBox;
